export default "__VITE_ASSET__768883e6__"